interface TagEntity {
  text: string;
  size: number;
  color: string;
  backgroundColor?: string;
}

export interface ThreeTagEntity { // 强制数组有3个值
  0: TagEntity;
  1: TagEntity;
  2: TagEntity;
}

export interface FourTagEntity extends ThreeTagEntity {
  3: TagEntity;
}

export interface CyclePrometeTag {
  backgroundColor: string;
  items: FourTagEntity
}

export interface SquarePrometeTag {
  shape: 'round' | 'triangle' | 'sawtooth';
  items: ThreeTagEntity
}

export const defaultCyclePrometeTags: CyclePrometeTag[] = [
  { 
    backgroundColor: '#F88020',
    items: [
      {
        text: '我们券后仅需',
        color: 'white',
        size: 12
      },
      {
        text: '1999.9',
        color: 'white',
        size: 24
      },
      {
        text: '促销价',
        color: '#E54600',
        size: 20,
        backgroundColor: '#FFF4E4'
      },
      {
        text: '速度抢',
        color: 'white',
        size: 14
      }
    ],
  },
  { 
    backgroundColor: '#2C7873',
    items: [
      {
        text: '我们券后仅需',
        color: 'white',
        size: 12
      },
      {
        text: '1999.9',
        color: 'white',
        size: 24
      },
      {
        text: '促销价',
        color: '#FFFFFF',
        size: 20,
        backgroundColor: '#FFC600'
      },
      {
        text: '速度抢',
        color: 'white',
        size: 14
      }
    ],
  },
  { 
    backgroundColor: '#4C80E4',
    items: [
      {
        text: '我们券后仅需',
        color: 'white',
        size: 12
      },
      {
        text: '1999.9',
        color: 'white',
        size: 24
      },
      {
        text: '促销价',
        color: '#FFFFFF',
        backgroundColor: '#2E279D',
        size: 20
      },
      {
        text: '速度抢',
        color: 'white',
        size: 14
      }
    ],
  }
]


const defaultTags: ThreeTagEntity = [
  {
    text: '19.9',
    color: 'white',
    size: 14
  },
  {
    text: '天猫Tmall',
    color: 'white',
    size: 14
  },
  {
    text: '省60元',
    color: 'white',
    size: 14
  }
]
export const defaultSquarePrometeTags: SquarePrometeTag[] = [
  {
    shape: 'round',
    items: defaultTags
  },
  {
    shape: 'triangle',
    items: defaultTags
  },
  {
    shape: 'sawtooth',
    items: defaultTags
  }
]